export default __webpack_public_path__ + "static/media/Settings-Grey.011ebb29.svg";